export const PHONE_NUMBER: string = '972-52-641-8602';
export const EMAIL: string = 'tomerhalali@gmail.com';
export const BLANK: string = '_blank';
export const RESUME_PATH: string = '/assets/resume/CV_Tomer_Halali.pdf';
export const RESUME_FILENAME: string = 'CV_Tomer_Halali.pdf';
